import { faGithub, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faLaptop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stars } from 'drei';
import React, { useEffect, useRef, useState } from 'react';
// Bootstrap
import { Card, Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { Canvas, useThree } from 'react-three-fiber';
import Peer from "simple-peer";
// WebRTC
import io from "socket.io-client";
import * as THREE from "three";
import { Physics } from 'use-cannon';
import { v1 as uuid } from "uuid";
import { Ground } from '../components/Ground';
import { Player } from '../components/Player';




function CreateRoom(props) {

    const { camera } = useThree();

    const peerObjectsDict = {};

    const [listenerForPA, setListenerForPA] = useState();

    const [sendStarted, setSendStarted] = useState(false);

    const audioSource = useRef();

    const playerRef = useRef();

    const container_ref = useRef();
    const scene_ref = useRef();
    
    // const peerPositionalAudioRef = useRef();
    const physicsRef = useRef();

    const [peers, setPeers] = useState([]);
    const socketRef = useRef();
    const userAudio = useRef();
    const peersRef = useRef([]);
    const roomID = "WAITING_ROOM"; // props.match.params.roomID;

    useEffect(() => {
        socketRef.current = io.connect("https://haunter-server.herokuapp.com/");
            socketRef.current.emit("join room", roomID);
            socketRef.current.on("all users", users => {
                const peers = [];
                users.forEach(userID => {
                    const peer = createPeer(userID, socketRef.current.id, null);
                    peersRef.current.push({
                        peerID: userID,
                        peer,
                    })
                    peers.push(peer);
                })
                setPeers(peers);
            })

            socketRef.current.on("user joined", payload => {
                const peer = addPeer(payload.signal, payload.callerID, null);

                peersRef.current.push({
                    peerID: payload.callerID,
                    peer,
                })

                setPeers(users => [...users, peer]);
            });

            socketRef.current.on("receiving returned signal", payload => {
                const item = peersRef.current.find(p => p.peerID === payload.id);
                item.peer.signal(payload.signal);
            });

            socketRef.current.on("move", playerMotion => {
                if(peerObjectsDict[playerMotion.peerID]) {
                    peerObjectsDict[playerMotion.peerID].position.set(playerMotion.position)
                    peerObjectsDict[playerMotion.peerID].rotation.set(playerMotion.rotation)
                }
            });
    }, []);

    function createPeer(userToSignal, callerID) {
        const peer = new Peer({
            initiator: true,
            trickle: false
        });

        peer.on("signal", signal => {
            socketRef.current.emit("sending signal", { userToSignal, callerID, signal })
        })

        peer.on("data", (e) => {
            const playerMotion = JSON.parse(e);

            if(peerObjectsDict[userToSignal] === null | peerObjectsDict[userToSignal] === undefined) {
                const geometry = new THREE.CylinderGeometry(0.2, 0.2, 1);
                const material = new THREE.MeshBasicMaterial( {color: 0x00FF00} );
                const peerBoxRef = new THREE.Mesh( geometry, material );
                peerBoxRef.position.set(-10 + Math.random() * (20), 0, -10 + Math.random() * (20));

                physicsRef.current.add(peerBoxRef);
                peerObjectsDict[userToSignal] = peerBoxRef;
            }

            if(peerObjectsDict[userToSignal]) {
                peerObjectsDict[userToSignal].position.set(playerMotion.position.x,playerMotion.position.y, playerMotion.position.z)
                peerObjectsDict[userToSignal].rotation.set(playerMotion.rotation._x,playerMotion.rotation._y,playerMotion.rotation._z)
            }
        });

        return peer;
    }

    function addPeer(incomingSignal, callerID) {
        const peer = new Peer({
            initiator: false,
            trickle: false
        })

        peer.on("signal", signal => {
            socketRef.current.emit("returning signal", { signal, callerID })
        })

        peer.on("data", (e) => {
            const playerMotion = JSON.parse(e);

            if(peerObjectsDict[callerID] === null | peerObjectsDict[callerID] === undefined) {
                const geometry = new THREE.CylinderGeometry(0.2, 0.2, 1);
                const material = new THREE.MeshBasicMaterial( {color: 0x00FF00} );
                const peerBoxRef = new THREE.Mesh( geometry, material );
                peerBoxRef.position.set(-10 + Math.random() * (20), 0, -10 + Math.random() * (20));

                physicsRef.current.add(peerBoxRef);
                peerObjectsDict[callerID] = peerBoxRef;
            }

            if(peerObjectsDict[callerID]) {
                peerObjectsDict[callerID].position.set(playerMotion.position.x,playerMotion.position.y, playerMotion.position.z)
                peerObjectsDict[callerID].rotation.set(playerMotion.rotation._x,playerMotion.rotation._y,playerMotion.rotation._z)
            }
        });

        peer.signal(incomingSignal);

        return peer;
    }

    const createRoom = (e) => {
        const id = uuid();
        props.history.push(`/room/${id}`);
    }

  return (
      <>
     <Navbar style={{background: 'none', backgroundColor: 'inherit', marginLeft: '8px', marginRight: '8px'}} sticky="top" expand="md">
                <Navbar.Brand style={{color: 'inherit', marginRight: '8px'}}>👻 <b>haunter</b></Navbar.Brand>
                <Nav className="ml-auto">
                    <Nav.Item style={{color: 'inherit'}}><Navbar.Text style={{color: 'inherit'}} className="small">[<a onClick={(e) => {createRoom(e)}} style={{color: 'red', cursor: 'pointer'}}>Create House</a>]</Navbar.Text></Nav.Item>
                </Nav>
            </Navbar>

    <Container style={{zIndex: '999', paddingRight: '16px', paddingLeft: '16px', display: 'float', position: 'relative'}} fluid='xs'>
            <Row>
                <Col md={{span: 3, offset: 9}}>
                    <Card style={{backgroundColor: 'none'}}>
                        <Card.Body style={{backgroundColor: 'none'}}>
                            You are currently in <b>Limbo</b> where you can freely roam around. Please create a house in order to connect your voice.
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col md={{span: 3, offset: 9}}>
                    <iframe style={{zIndex: '9999', borderRadius: '15px'}} width="100%" height="264px" src="https://www.youtube.com/embed/videoseries?list=PL-FWt4ZQtjZoRkeIJBatq-kx0XFB4XRL7" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay></iframe>
                </Col>
            </Row>
    </Container>

    <Canvas shadowMap colorManagement onClick={(e) => {setSendStarted(true)}} style={{height: '100vh', position: 'absolute', top: '0px', bottom: '0px'}}>
    <Stars
        color="black"
        radius={100} // Radius of the inner sphere (default=100)
        depth={50} // Depth of area where stars should fit (default=50)
        count={5000} // Amount of stars (default=5000)
        factor={4} // Size factor (default=4)
        saturation={0} // Saturation 0-1 (default=0)
        fade // Faded dots (default=false)
        />
      <ambientLight intensity={0.25} />
      <pointLight castShadow intensity={0.7} position={[100, 100, 100]} />
      <group ref={scene_ref}></group>
      <Physics gravity={[0, 0, 0]}>
        <Ground position={[0, 0, 0]} />
        <Player sendStarted={true} peersRef={peersRef} socketRef={socketRef} listenerForPA={listenerForPA} position={[0, 3, 10]} />
        <group ref={physicsRef}></group>
      </Physics>
    </Canvas>

    <Navbar style={{height: '60px', width: 'calc(100% - 16px)', position: 'absolute', top: 'calc(100vh - 60px)', marginLeft: '8px', marginRight: '8px'}} sticky="bottom" className="footer" expand="sm">
                <Navbar.Text className="small" style={{color: 'inherit'}}>© Gokhan Egri 2021</Navbar.Text>
                <Nav className="ml-auto">
                    <Row>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://egrigokhan.github.io"><FontAwesomeIcon icon={faLaptop} size="sm"/></Nav.Link></Col>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://github.com/egrigokhan"><FontAwesomeIcon icon={faGithub} size="sm"/></Nav.Link></Col>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://twitter.com/gokhan_egri"><FontAwesomeIcon icon={faTwitter} size="sm"/></Nav.Link></Col>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://www.linkedin.com/in/gokhan-egri"><FontAwesomeIcon icon={faLinkedin} size="sm"/></Nav.Link></Col>
                    </Row>
                </Nav>
            </Navbar>
    </>
  );
}

export default CreateRoom;
